const data = {
  id: 0,
  curation: require("./1/curation").default,
};

export default data;
